import { render, staticRenderFns } from "./ActivePromotions.vue?vue&type=template&id=63b62193&scoped=true&"
import script from "./ActivePromotions.vue?vue&type=script&lang=js&"
export * from "./ActivePromotions.vue?vue&type=script&lang=js&"
import style0 from "./ActivePromotions.vue?vue&type=style&index=0&id=63b62193&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b62193",
  null
  
)

export default component.exports